import React, { useCallback } from 'react';
import Link from '../../../Link';
import Icon from '../../../icons/Icon';
import { useEventHasMap } from '../../../../../data/hooks/eventHooks';
import { useDispatch } from 'react-redux';

function MapIcon(props) {
    const { event } = props,
        hasMap = useEventHasMap(event.id),
        dispatch = useDispatch();

    const handleClick = useCallback(() => {
        dispatch(app.actions.ui.sidePanel.showEventMap(true));
    }, []);

    if (!hasMap) return null;

    return (
        <Link onClick={handleClick}>
            <Icon src="/img/event_map.png" color="white" />
        </Link>
    );
}

export default MapIcon;
